import React from "react";
import Dropdown from "../generic/Dropdown"; // Assuming Dropdown component is in the same directory

interface ColorDropdownProps {
    colorOptions: { label: string; value: string }[];
    selectedColor: string | null;
    onSelectColor: (colorCode: string | null) => void;
    required?: boolean;
}

const ColorDropdown: React.FC<ColorDropdownProps> = ({
                                                         colorOptions,
                                                         selectedColor,
                                                         onSelectColor,
                                                         required = true,
                                                     }) => {
    const handleColorChange = (color: string | null) => {
        onSelectColor(color); // Pass the selected color to the parent component
    };

    return (
        <div>
            <Dropdown
                label="Material Color"
                options={colorOptions}
                selectedValue={selectedColor}
                onChange={handleColorChange}
                placeholder="Select a color"
                required={required}
            />
        </div>
    );
};

export default ColorDropdown;
